import { useEffect, useState } from 'react'
import Cookies from 'js-cookie'
import { baseAxiosComplete } from '../tool/axios'
import defaultUserIcon from '../images/default_user_icon.png'
import UserData from '../js/userData'

export default function HeaderUserMenu() {

    const [userData, setUserData] = useState<any>({ user_name: '', phone: '' })

    useEffect(() => {
        let data: any = localStorage.getItem('userData')
        let d = JSON.parse(data)
        setUserData(d)
    }, [])

    const logOut = () => {
        baseAxiosComplete.post('/global/login_out', {
            out_type: 9999
        }).then((res: any) => {
            if (res.status === 0) {
                Cookies.set('token', '')
                window.location.reload()
            }
        })
    }

    return <div id="header-user-menu" className="clear">
        <div className="fl">
            <img src={defaultUserIcon} style={{ width: 32 }} alt="" />
        </div>

        <div className="fl clear userinfo" style={{ margin: '0 10px' }} >
            <span className="fl">{UserData.user_name}</span>
        </div>

        <div className="fl"><a onClick={logOut}>退出</a></div>
    </div>
}